import React, { useState } from 'react';
import { BroadcastNotificationDetail } from '../../../../model/notifications/notifications';
import styles from './ScrollNotification.module.scss';
import bellGif from '../../../../assets/gifs/notification-bell-icon.gif';
import { ChevronRightIcon } from '../../../../assets/icons';
import MessageModal from '../../../../common/ekedc-components/message-modal/MessageModal';

interface ScrollNotificationProps {
    notification: BroadcastNotificationDetail;
}

const ScrollNotification: React.FC<ScrollNotificationProps> = ({ notification }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (notification.turnOnOff === false || !notification.message) return null;

    return (
        <>
            <div className={styles.container}>
                <button
                    type="button"
                    className={styles.iconContainer}
                    onClick={() => setIsModalOpen(true)}
                    aria-label="Open announcement"
                >
                    <img className={styles.icon} src={bellGif} alt="" />
                </button>
                <div className={styles.marquee}>
                    <div className={styles.track}>
                        <span className={styles.message}>{notification.message}</span>
                        <span className={styles.message} aria-hidden="true">{notification.message}</span>
                    </div>
                </div>
                <ChevronRightIcon className={styles.chevron} />
            </div>

            {isModalOpen && (
                <MessageModal
                    icon={<img src={bellGif} alt="" width={96} height={96} />}
                    title={notification.title}
                    message={notification.message}
                    onClose={() => setIsModalOpen(false)}
                />
            )}
        </>
    );
};

export default ScrollNotification;
